module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/aviator-glasses.png?de16bd3259831ab2a8e0af6f84c38b9d";